import HttpCliente from "../HttpCliente";

export const getLogsPaginado = (pageNumber, pageSize, filtros, token) => {
    return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams({
            pageNumber: pageNumber,
            pageSize: pageSize,
            fechaDesde: filtros.fechaDesde || '',
            fechaHasta: filtros.fechaHasta || '',
            proceso: filtros.proceso || '',
        });

        HttpCliente.get(`/Log/ObtenerLogsPaginados?${queryParams}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json',
            }
        }).then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error);
        });
    }
    );
};

export const exportLogsToExcel = (filtros, token) => {
    return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams({
            fechaDesde: filtros.fechaDesde || '',
            fechaHasta: filtros.fechaHasta || '',
            proceso: filtros.proceso || ''
        });

        HttpCliente.get(`/Log/ExportarExcel?${queryParams}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            responseType: 'blob'
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'logs.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            resolve(response.data);
        })
        .catch(error => {
            reject(error);
        });
    });
};